import React from "react"
import { FileText, FileImage, FileVideo, FileSpreadsheet, File } from "lucide-react"
import { fileKind } from "../constants"

const ICONS = {
  pdf: { Icon: FileText, className: "bg-red-50 text-red-500" },
  image: { Icon: FileImage, className: "bg-violet-50 text-violet-500" },
  video: { Icon: FileVideo, className: "bg-blue-50 text-blue-500" },
  sheet: { Icon: FileSpreadsheet, className: "bg-emerald-50 text-emerald-600" },
  doc: { Icon: FileText, className: "bg-sky-50 text-sky-600" },
  file: { Icon: File, className: "bg-slate-100 text-slate-500" },
}

export function DocumentIcon({ contentType, fileName, size = "md" }) {
  const kind = fileKind(contentType, fileName)
  const { Icon, className } = ICONS[kind] || ICONS.file
  const dims = size === "sm" ? "h-9 w-9" : "h-11 w-11"
  const iconDims = size === "sm" ? "h-4 w-4" : "h-5 w-5"
  return (
    <span className={`flex ${dims} shrink-0 items-center justify-center rounded-xl ${className}`}>
      <Icon className={iconDims} />
    </span>
  )
}
